/** @jsx h */
import h from '../../../components/Database/utils/hyperscript';
export default h("database", {
  title: "\uD83C\uDDF5\uD83C\uDDF9Offslite #6 - Lisbon "
}, h("columns", null, h("column", {
  key: "name",
  name: "Name",
  type: "name"
}), h("column", {
  key: "description",
  name: "Description",
  type: "text"
}), h("column", {
  key: "invoice",
  name: "Invoice provided?",
  type: "todo"
}), h("column", {
  key: "amount",
  name: "Amount",
  type: "number"
})), h("records", null, h("record", null, h("name", null, "Airbnb"), h("description", null, "Flat of 15 beds"), h("invoice", {
  checked: true
}), h("amount", null, "1500")), h("record", null, h("name", null, "Flights"), h("description", null, "13 flights"), h("invoice", {
  checked: true
}), h("amount", null, "2400")), h("record", null, h("name", null, "Food for picnics"), h("description", null, "3 meals"), h("amount", null, "187")), h("record", null, h("name", null, "Escape game"), h("description", null, "Activity"), h("amount", null, "280"))));